import * as React from 'react';

import {Body} from '../../typography/body';
import type {Color} from '../../typography/body';

type Props = {
    color?: Color;
    text: string;
};

export function AiHomepageHeader(props: Props) {
    return (
        <Body size='xlarge' isBold={true} useDoyle={true} color={props.color}>
            {props.text}
        </Body>
    );
}
